import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import AuthorInfo from '@/features/editorial/components/AuthorInfo.vue';
import ListArticleList from '@/features/editorial/components/article/list/ListArticleList.vue';
import RelatedArticles from '@/features/editorial/components/article/RelatedArticles.vue';
import ListArticleStats from '@/features/editorial/components/article/list/ListArticleStats.vue';
import AdUnit from '@/components/AdUnit.vue';
import ListOffersComparison from '@/features/editorial/components/ListOffersComparison.vue';
import TrendingArticles from '@/features/editorial/components/article/TrendingArticles.vue';

import { getHeaderImage } from '@/features/editorial/helpers/editorial-helper';

import type { ListArticleData } from '@/features/editorial/types/editorial-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListArticle',
  props: {
    article: null
  },
  setup(__props: any) {

const props = __props as {
	article: ListArticleData;
};



const titleList = computed(() => {
	const node = props.article.mainObjects[0]?.node;
	return node?.__typename === 'GenericTitleList' ? node : null;
});

const listSize = computed(() => titleList.value?.titles.totalCount ?? 0);

return { __sfc: true,props, titleList, listSize, PictureComp, AuthorInfo, ListArticleList, RelatedArticles, ListArticleStats, AdUnit, ListOffersComparison, TrendingArticles, getHeaderImage }
}

})